var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_modal)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"content"},[_vm._t("default"),_c('div',{on:{"click":_vm.toggleModal}},[_c('fc-icon',{attrs:{"type":"56_del"}})],1)],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }